import { render, staticRenderFns } from "./formItemProperties.vue?vue&type=template&id=33cb9c6f"
import script from "./formItemProperties.vue?vue&type=script&lang=js"
export * from "./formItemProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports